export default "__VITE_ASSET__C$GxZ_YC__"